import * as React from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { FAB, Provider } from 'react-native-paper';
import { Logger } from 'aws-amplify';

import { Group } from '../components/group';
import Reading, { options } from '../components/reading';
import { OracleParamList } from '../types';
import { Statement } from '../constants/datagram';
import useTranslation from '../hooks/translation';

const logger = new Logger('oracle');

const OracleStack = createStackNavigator<OracleParamList>();

export default function OracleNavigator() {
  useTranslation();

  return (
    <OracleStack.Navigator>
      <OracleStack.Screen
        name="Oracle"
        component={OracleScreen}
        options={{ headerShown: false }}
      />
      <OracleStack.Screen
        name="Querying"
        component={OracleScreen}
        options={options}
        listeners={{
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          state: (e) => {
            // oracle reading screen received eat bottom-tab-navigator from OracleScreen
          }
        }}
      />
    </OracleStack.Navigator>
  );
}

function OracleScreen() {
  const navigation = useNavigation();

  const [state, setState] = React.useState({ open: false } as Group);
  const route = useRoute();
  const params = route.params as OracleParamList;
  const reading = (params && params.reading) || undefined;

  const onStateChange = ({ open }: Group) => setState({ open });

  const { open } = state;

  return (
    <Provider>
      {/* <View style={styles.container}> */}
      {reading ? <Reading lines={reading.lines as Statement} /> : undefined}
      <FAB.Group
        open={open}
        visible
        icon={open ? 'calendar-today' : 'plus'}
        actions={[
          {
            icon: 'plus',
            onPress: () =>
              navigation.navigate('Querying', {
                reading: { lines: [7, 9, 7, 7, 9, 7] }
              })
          },
          {
            icon: 'star',
            label: 'Star',
            onPress: () => logger.debug('Pressed star')
          },
          {
            icon: 'email',
            label: 'Email',
            onPress: () => logger.debug('Pressed email')
          },
          {
            icon: 'bell',
            label: 'Remind',
            onPress: () => logger.debug('Pressed notifications')
          }
        ]}
        onStateChange={onStateChange}
        onPress={() => {
          if (open) {
            // do something if the speed dial is open
          }
        }}
      />
      {/* </View> */}
    </Provider>
  );
}

// const styles = StyleSheet.create({
//   container: {
//     // flex: 1,
//     alignItems: 'center',
//     justifyContent: 'center'
//   },
//   title: {
//     fontSize: 20,
//     fontWeight: 'bold'
//   },
//   separator: {
//     marginVertical: 30,
//     height: 1,
//     width: '80%'
//   }
// });
